import type {ScriptBlockData} from '../components/story/ScriptBlock';
import {dualFor, scriptTextFields} from './scriptDualDialogue';

export function scriptDialogueStatistics(blocks:readonly ScriptBlockData[]) {
    const characterDialogue:Record<string,{lines:number;words:number}>={};
    let current='',totalDialogueLines=0,totalWords=0;
    const words=(text:string) => text.split(/\s+/).filter(Boolean).length;
    const count=(part:Pick<ScriptBlockData,'type'|'content'>) => {
        if(part.type==='character') current=part.content.toUpperCase().replace(/\s*\(.*?\)\s*$/g,'').trim();
        if(part.type==='dialogue') {
            totalDialogueLines++;
            if(current) {
                characterDialogue[current] ??= {lines:0,words:0};
                characterDialogue[current].lines++; characterDialogue[current].words+=words(part.content);
            }
        }
    };
    for(const block of blocks) {
        totalWords+=scriptTextFields(block).reduce((sum,p) => sum+words(p.text),0);
        if(block.type==='dual-dialogue') {
            try {const data=dualFor(block); for(const side of ['left','right'] as const) {current='';data[side].forEach(count);}}
            catch { /* Retain malformed input; layout/export provides its error. */ }
            current='';
        } else count(block);
    }
    return {characterDialogue,totalDialogueLines,totalWords};
}
